<script lang="ts">
  import { theme } from '$stores/theme.svelte';

  interface Props {
    size?: number;
  }
  let { size = 72 }: Props = $props();

  const isBrutalist = $derived(theme.current === 'brutalist');
  const pngSize = $derived(size <= 48 ? 48 : size <= 96 ? 96 : size <= 128 ? 128 : 192);
  const modernSrc = $derived(`/icons/icon-${pngSize}.png`);
  const brutalistSrc = $derived(`/icons/brutalist/icon-${pngSize}.png`);
  const src = $derived(isBrutalist ? brutalistSrc : modernSrc);
</script>

<span class="brand-icon" style:width="{size}px" style:height="{size}px" aria-hidden="true">
  <img {src} alt="" width={size} height={size} />
</span>

<style>
  .brand-icon {
    display: block;
    flex-shrink: 0;
    line-height: 0;
  }
  .brand-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 22.37%;
  }
  :global([data-theme='brutalist']) .brand-icon img {
    border-radius: 0;
    border: 3px solid var(--text);
    box-shadow: 4px 4px 0 var(--text);
  }
</style>
